/* eslint-disable functional/prefer-readonly-type */
import React from 'react'
import { Grid } from '@mui/material'
import { State } from '@hookstate/core'
import FilterSelectPeriod from '~/components/FilterAutocompletePeriod'
import FieldAutocompleteRegistration from '~/components/FieldAutocompleteRegistration'
import IWeaponType from '~/features/WeaponType/interfaces/IWeaponType'
import { IWeaponKind } from '~/features/Management/interfaces'
import ICircunstance from '~/features/Circunstance/interfaces/ICircunstance'
import IDestination from '~/features/Destination/interfaces/IDestination'

interface WeaponFiltersProps {
  readonly weaponType: State<IWeaponType | null>
  readonly weaponKind: State<IWeaponKind | null>
  readonly weaponCircunstance: State<ICircunstance | null>
  readonly destinationWeaponId: State<IDestination | null>
  readonly getDestinations: <T = Record<string, string>>(id?: string) => Promise<readonly T[]>
  readonly getWeaponTypes: <T = Record<string, string>>(id?: string) => Promise<readonly T[]>
  readonly getWeaponKinds: <T = Record<string, string>>(id?: string) => Promise<readonly T[]>
  readonly getCircunstances: <T = Record<string, string>>(id?: string) => Promise<readonly T[]>
  readonly translate: (key: string) => string
  readonly disableFields?: boolean
  readonly setStartDate: (date: string | null) => void
  readonly setFinishDate: (date: string | null) => void
  readonly initialPeriod: State<string>
}

export default function WeaponFilters({
  weaponType,
  weaponCircunstance,
  weaponKind,
  destinationWeaponId,
  getWeaponTypes,
  getWeaponKinds,
  getCircunstances,
  getDestinations,
  translate,
  disableFields,
  setStartDate,
  setFinishDate,
  initialPeriod,
}: WeaponFiltersProps) {
  return (
    <Grid container spacing={1}>
      <Grid item xs={2}>
        <FieldAutocompleteRegistration
          valueId={weaponType.get()?.id as string}
          label={translate('Weapon Type')}
          onValueChange={(weaponTypeItem) => weaponType.set(weaponTypeItem as unknown as IWeaponType)}
          optionsFetch={getWeaponTypes}
          disabled={disableFields}
        />
      </Grid>

      <Grid item xs={2}>
        <FieldAutocompleteRegistration
          depends={weaponType.get()?.id as string}
          valueId={weaponKind.get()?.id as string}
          label={translate('Weapon Kind')}
          onValueChange={(weaponKindItem) => weaponKind.set(weaponKindItem)}
          optionsFetch={getWeaponKinds}
          disabled={!weaponType.get()}
        />
      </Grid>

      <Grid item xs={2}>
        <FieldAutocompleteRegistration
          label={translate('Circunstance')}
          onValueChange={(weaponCircunstanceItem) => weaponCircunstance.set(weaponCircunstanceItem)}
          valueId={weaponCircunstance.get()?.id as string}
          optionsFetch={getCircunstances}
          disabled={disableFields}
        />
      </Grid>
      <Grid item xs={2}>
        <FieldAutocompleteRegistration
          label={translate('Destination')}
          onValueChange={(destination) => destinationWeaponId.set(destination)}
          valueId={destinationWeaponId.get()?.id as string}
          optionsFetch={getDestinations}
          disabled={disableFields}
        />
      </Grid>
      <FilterSelectPeriod
        required
        onStartDateChange={(value) => setStartDate(value?.toJSON() ?? null)}
        onFinishDateChange={(value) => setFinishDate(value?.toJSON() ?? null)}
        onPeriodChange={(value) => initialPeriod.set(value)}
        period={initialPeriod.get()}
        sxPeriod={{ pl: 0, pt: 0 }}
        sxInitialDate={{ pl: 1, pt: 0 }}
        sxFinalDate={{ pl: 1, pt: 0 }}
      />
    </Grid>
  )
}
